module.exports = new __parcel__URL__("mercenary_wolvez_hideout_level_3.ba20d9cd.png").toString();